export default function addDelayedMouseover(element, delay, callback) {
  let timeout = null

  element.addEventListener('mouseover', e => {
    if (timeout) { return }

    timeout = setTimeout(() => {
      timeout = null
      callback(e)
    }, delay)
  })

  element.addEventListener('mouseout', _e => {
    clearTimeout(timeout)
    timeout = null
  })
}
